export default __webpack_public_path__ + "static/media/resume.b112752b.pdf";